import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-sop-menu',
  templateUrl: './sop-menu.component.html',
  styleUrls: ['./sop-menu.component.css']
})
export class SopMenuComponent implements OnInit {
    sopKeyno;

    public menu?: Menu;

    public selectListFieldTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.sopKeyno = this.stateService.getStateParams()['sop_keyno'];
    }

    private async loadMenu() {
        if (!!this.sopKeyno) {
            this.menu = (await this.datatask.Post(1839, { sop_keyno: this.sopKeyno }))[0];
        }
    }

    private async loadFieldTypes(): Promise<void> {
        this.selectListFieldTypes = await this.datatask.Post(1837);
    }

    private async init() {
        await this.loadMenu();
        this.loadFieldTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    sop_keyno: number;
    sop_name: string;
    sop_fieldtype: string;
    orderby: number;
    nbr_of_sopcl: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('sopMenu', {
//        templateUrl: 'views/components/views/sopMenu/sopMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', '$q', 'sopService', 'sopMenuService', function ($stateParams, $q, sopService, sopMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let sopKeyno = $stateParams.sop_keyno;

//            vm.model = {
//                menu: {},
//                selectListFieldTypes: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadMenu = function () {
//                sopMenuService.getMenu({ sop_keyno: sopKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.menu);
//                });
//            };

//            let loadFieldTypes = function () {
//                const deferred = $q.defer();

//                sopService.listFieldTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListFieldTypes);

//                    loadMenu();

//                    deferred.resolve();
//                });

//                return deferred.promise;
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadFieldTypes();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
